module.exports = __webpack_public_path__ + "static/media/ES-Uab.0287a0ba.png";